document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-loop-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!track) return;

    const move = (direction) => {
      const card = track.querySelector(':scope > *');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let autoplay;
      const startAutoplay = () => {
        window.clearInterval(autoplay);
        autoplay = window.setInterval(() => {
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
          if (atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            move(1);
          }
        }, 4200);
      };

      const stopAutoplay = () => window.clearInterval(autoplay);
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
      startAutoplay();
    }
  });

  document.querySelectorAll('[data-loop-purchase]').forEach((purchase) => {
    const planInput = purchase.querySelector('[data-selling-plan-input]');
    const submitLabel = purchase.querySelector('[data-submit-label]');
    const oneTimePrice = purchase.dataset.oneTimePrice || '';
    const subscriptionPrice = purchase.dataset.subscriptionPrice || '';

    purchase.querySelectorAll('input[name="loop_purchase_option"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const isSubscription = radio.value === 'subscription';
        if (planInput) planInput.disabled = !isSubscription;
        if (submitLabel) {
          submitLabel.textContent = `AÑADIR A LA BOLSA — ${isSubscription ? subscriptionPrice : oneTimePrice}`;
        }
      });
    });
  });
});
